class LocalizationBundle extends HTMLElement {
  constructor() {
    super();
    this.countrySelect = this.querySelector('[data-country-select]');
    this.languageSelect = this.querySelector('[data-language-select]');
    this.currencyInput = this.querySelector('.currency-input');
    this.saveButton = this.querySelector('[data-save-localization]');
    this.form = this.querySelector('form');
    this.countryCodeInput = this.querySelector('input[name="country_code"]');
    this.localeCodeInput = this.querySelector('input[name="locale_code"]');

    // Set initial locale code value
    if (this.languageSelect && this.localeCodeInput) {
      this.localeCodeInput.value = this.languageSelect.value;
      console.log('Initial locale code set:', this.localeCodeInput.value);
    }

    console.log('currency-input', this.currencyInput);
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.countrySelect) {
      // Listen for native select changes
      this.countrySelect.addEventListener('change', (event) => {
        if (this.countryCodeInput) {
          this.countryCodeInput.value = event.target.value;
        }
        // Add currency update
        if (this.currencyInput) {
          const selectedOption = event.target.options[event.target.selectedIndex];
          const currency = selectedOption.dataset.currency;

          if (currency) {
            this.currencyInput.value = currency;
          }
        }
      });

      // Listen for custom select changes
      const customSelect = this.querySelector('custom-select');
      if (customSelect) {
        customSelect.addEventListener('change', (event) => {
          if (this.countryCodeInput) {
            this.countryCodeInput.value = event.target.value;
            console.log('Updated country code to:', event.target.value);
          }
          // Add currency update
          if (this.currencyInput) {
            const selectedOption = event.target.selectedOption;
            console.log('selectedOption', selectedOption);
            const currency = selectedOption?.dataset.currency;
            if (currency) {
              this.currencyInput.value = currency;
              console.log('Updated currency to:', currency);
            }
          }
        });
      }
    }

    if (this.languageSelect) {
      // Listen for native language select changes
      this.languageSelect.addEventListener('change', (event) => {
        if (this.localeCodeInput) {
          console.log('languageSelect event', event);
          this.localeCodeInput.value = this.languageSelect.value;
          console.log('Updated locale code to:', event.target.value);
        }
      });

      // Listen for custom language select changes
      const customLanguageSelect = this.querySelector('custom-select[data-language-select]');
      if (customLanguageSelect) {
        customLanguageSelect.addEventListener('change', (event) => {
          if (this.localeCodeInput) {
            this.localeCodeInput.value = event.target.value;
            console.log('Updated locale code to:', event.target.value);
          }
        });
      }
    }

    if (this.saveButton) {
      this.saveButton.addEventListener('click', (event) => {
        event.preventDefault();
        console.log('Form state before submission:', {
          countryCode: this.countryCodeInput?.value,
          localeCode: this.localeCodeInput?.value,
          formAction: this.form?.action,
          formMethod: this.form?.method,
        });

        if (this.form) {
          this.form.submit();
        }
      });
    }
  }
}

customElements.define('localization-bundle', LocalizationBundle);
